import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import InputGroup from 'react-bootstrap/InputGroup'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'

import { HiddenInput, Sumatoria } from './HiddenInput'
import { FormGroup } from 'react-bootstrap'
import { LEGAJO_UNICO } from 'utils/legajo'

function DatosActividad({
  datos,
  data,
  bimestre,
  legajo,
  actividad,
  minimoPrincipal
}) {
  const { register, watch, errors, getValues } = useFormContext()
  const [principalSuperaMinimo, setPrincipalSuperaMinimo] = useState(false)
  const [cualquieraSuperaMinimo, setCualquieraSuperaMinimo] = useState(false)

  const stateLegajo = watch(`${bimestre}.${legajo}`, {})

  useEffect(() => {
    let posible = true

    if (posible) {
      let datosPrincipal = datos.filter(
        (item) => item.legajo === Number(legajo.slice(3)) && item.tipo === 'P'
      )[0]

      let principal = Object.values(stateLegajo).filter(
        (item) => item.catID === String(datosPrincipal.actividad)
      )[0]

      let crudo = principal?.baseImponible * datosPrincipal?.tasa
      setPrincipalSuperaMinimo(crudo > minimoPrincipal)
    }

    return () => {
      posible = false
    }
  }, [
    bimestre,
    legajo,
    stateLegajo,
    datos,
    setPrincipalSuperaMinimo,
    minimoPrincipal
  ])

  useEffect(() => {
    let mounted = true

    if (mounted) {
      let result = datos
        .map((item) => {
          let minimo = item?.minimoTasa
          let crudo =
            stateLegajo?.[`act${item.actividad}`]?.baseImponible * item?.tasa

          return crudo > minimo
        })
        .filter(Boolean)[0]
      setCualquieraSuperaMinimo(result)
    }

    return () => {
      mounted = false
    }
  }, [bimestre, legajo, stateLegajo, datos, setCualquieraSuperaMinimo])

  return (
    <>
      <Container className="text-normal my-4">
        <Row
          style={{ display: data.legajo === LEGAJO_UNICO ? 'none' : 'block' }}
        >
          <Col md={3} className="text-muted text-uppercase">
            Legajo
          </Col>
          <Col>{data.legajo}</Col>
        </Row>
        <Row>
          <Col md={3} className="text-muted text-uppercase">
            Actividad {data.tipo === 'P' ? 'Principal' : 'Secundaria'}
          </Col>
          <Col>
            {data.codigo} - {data.descripcion}
          </Col>
        </Row>

        <Form.Row className="my-3">
          <Col md={3} className="text-muted text-uppercase">
            <Form.Label>Base Imponible (neta)</Form.Label>
          </Col>
          <FormGroup as={Col}>
            <InputGroup>
              <InputGroup.Prepend
                className="input-group-addon"
                style={{ top: '25px' }}
              >
                <InputGroup.Text id="inputGroupPrepend">$</InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="number"
                onWheel={(e) => e.target.blur()}
                placeholder="Ingrese base imponible"
                aria-describedby="inputGroupPrepend"
                name={`${bimestre}.${legajo}.${actividad}.baseImponible`}
                defaultValue={watch(
                  `${bimestre}.${legajo}.${actividad}.baseImponible`
                )}
                ref={register({
                  required: {
                    value: true,
                    message: 'Es necesario ingresar la base imponible.'
                  },
                  min: {
                    value: 0,
                    message: 'Debe ser un número positivo.'
                  }
                })}
                isInvalid={
                  !!errors?.[bimestre]?.[legajo]?.[actividad]?.baseImponible
                }
                isValid={
                  !errors?.[bimestre]?.[legajo]?.[actividad]?.baseImponible &&
                  getValues(`${bimestre}.${legajo}.${actividad}.baseImponible`)
                }
              />
              <Form.Control.Feedback type="invalid">
                {
                  errors?.[bimestre]?.[legajo]?.[actividad]?.baseImponible
                    ?.message
                }
              </Form.Control.Feedback>
            </InputGroup>
          </FormGroup>
        </Form.Row>

        <Row className="d-flex justify-content-center">
          <span className="text-muted text-uppercase">
            Tasa ({data.tasa * 100}%)
          </span>
          <HiddenInput
            name={`${bimestre}.${legajo}.${actividad}.alicuota`}
            base={`${bimestre}.${legajo}.${actividad}.baseImponible`}
            factor={data.tasa}
            minimo={data.minimoTasa}
            tipoActividad={data.tipo}
            principalSuperaMinimo={principalSuperaMinimo}
            year={data.year}
            cualquieraSuperaMinimo={cualquieraSuperaMinimo}
          />

          <span className="text-muted text-uppercase">
            FSP ({data.fsp * 100}%)
          </span>
          <HiddenInput
            base={`${bimestre}.${legajo}.${actividad}.alicuota`}
            name={`${bimestre}.${legajo}.${actividad}.fsp`}
            factor={data.fsp}
            fsp={true}
            tipoActividad={data.tipo}
            minimo={data.minimoFSP}
            principalSuperaMinimo={principalSuperaMinimo}
            year={data.year}
            cualquieraSuperaMinimo={cualquieraSuperaMinimo}
          />
        </Row>

        <Row className="my-3">
          <Col md={3} className="text-muted text-uppercase">
            Sumatoria
          </Col>
          <Sumatoria
            fspString={`${bimestre}.${legajo}.${actividad}.fsp`}
            tasaString={`${bimestre}.${legajo}.${actividad}.alicuota`}
            name={`${bimestre}.${legajo}.${actividad}.total`}
          />
        </Row>
      </Container>

      <input
        style={{ display: 'none' }}
        name={`${bimestre}.${legajo}.${actividad}.legajo`}
        defaultValue={data.legajo}
        ref={register({ required: true })}
      />

      <input
        style={{ display: 'none' }}
        name={`${bimestre}.${legajo}.${actividad}.anio`}
        defaultValue={data.year}
        ref={register({ required: true })}
      />

      <input
        style={{ display: 'none' }}
        name={`${bimestre}.${legajo}.${actividad}.catID`}
        defaultValue={data.actividad}
        ref={register({ required: true })}
      />

      <input
        style={{ display: 'none' }}
        name={`${bimestre}.${legajo}.${actividad}.bimestre`}
        defaultValue={bimestre.slice(-1)[0]}
        ref={register({ required: true })}
      />

      <hr />
    </>
  )
}

export default DatosActividad
